import { createSelector } from '@ngrx/store';

import { selectCoreState } from '../reducers';

export const getSideMenuState = createSelector(selectCoreState, state => state.sideMenu);
export const getSideMenuSelectedOption = createSelector(getSideMenuState, state => state.selectedOption);
export const getSideMenuOpen = createSelector(getSideMenuState, state => state.open);
